export default {
  path: '/talentSquare/detail',
  name: 'talentSquareDetail',
  meta: {
    title: '候选人详情',
  },
  component: () =>
    import(
      /* webpackChunkName: "talentSquareDetail" */ '@/pages/talentSquareDetail/index.vue'
    ),
}
